import { theme } from '../../config';
import { MetricTarget } from '../../enum';
export var ANNUAL_REPORT_ROWS = {
    serviceLevelForecast: 'serviceLevelForecast',
    asa: 'asa',
    abandonmentRate: 'abandonmentRate',
    occupancy: 'occupancy',
    productivity: 'productivity',
    productionHours: 'productionHours',
    productiveHours: 'productiveHours',
    shrinkage: 'shrinkage',
    attrition: 'attrition',
    productionFte: 'productionFte',
    requiredFte: 'requiredFte',
    requiredHeadcount: 'requiredHeadcount',
    requiredAgents: 'requiredAgents',
    effectiveAgents: 'effectiveAgents',
    different: 'different',
    effectiveRate: 'effectiveRate',
    agentsSalaries: 'agentsSalaries',
    supportStaffSalaries: 'supportStaffSalaries',
    hiringAhead: 'hiringAhead',
    overtimeCosts: 'overtimeCosts',
    totalBudgets: 'totalBudgets',
    defQueue: 'defQueue',
    nonDefQueue: 'nonDefQueue',
    supportStaff: 'supportStaff',
    costPerWork: 'costPerWork',
    staffSalaries: 'staffSalaries',
    threshold: 'threshold',
    multiSkill: 'multiSkill',
    seatsRequired: 'seatsRequired',
};
export var metricTargetMap = {
    asa: MetricTarget.ASA,
    occupancy: MetricTarget.Occupancy,
    serviceLevelForecast: MetricTarget.ServiceLevel,
};
export var SERVICE_ROWS = {
    defQueue: ['productivity'],
    nonDefQueue: ['serviceLevelForecast', 'asa', 'occupancy', 'abandonmentRate'],
};
export var AGENT_ROWS = {
    defQueue: ['requiredAgents'],
    nonDefQueue: ['requiredAgents'],
    multiSkill: ['requiredAgents'],
    both: ['requiredAgents', 'effectiveAgents', 'different', 'effectiveRate'],
};
export var PRODUCTION_HOURS_ROWS = {
    defQueue: ['productionHours'],
    nonDefQueue: ['productionHours'],
    multiSkill: ['productionHours'],
    both: ['productionHours'],
};
export var BUDGET_ROWS = {
    both: ['totalBudgets'],
};
export var SUPPORT_STAFF_ROWS = {
    both: ['supportStaff'],
};
export var SUPPORT_STAFF_SALARIES_ROWS = {
    both: ['supportStaffSalaries'],
};
export var COST_ROWS = {
    both: ['costPerWork'],
};
export var AGENT_SALARIES_ROWS = {
    both: ['agentsSalaries'],
};
export var OCCUPANCY_ROWS = {
    defQueue: ['productivity'],
    nonDefQueue: ['occupancy'],
    multiSkill: ['occupancy'],
};
export var INCLUDE_ROLE = ['staffSalaries', 'supportStaff'];
export var PERCENTAGES = [
    'productivity',
    'serviceLevelForecast',
    'abandonmentRate',
    'occupancy',
    'shrinkage',
    'effectiveRate',
];
export var CURRENCY = [
    'staffSalaries',
    'agentsSalaries',
    'supportStaffSalaries',
    'hiringAhead',
    'overtimeCosts',
    'totalBudgets',
    'costPerWork',
];
export var HIDE_ROW = ['agentsSalaries', 'supportStaffSalaries'];
export var CALCULATE_DIFF = [
    'requiredAgents',
    'supportStaff',
    'effectiveAgents',
    'productionHours',
    'productiveHours',
    'attrition',
    'productionFte',
    'requiredFte',
    'requiredHeadcount',
    'seatsRequired',
    'totalBudgets',
    'agentsSalaries',
    'hiringAhead',
    'overtimeCosts',
    'costPerWork',
];
export var BOLD_ROW = ['productionHours', 'requiredAgents'];
export var DECIMAL_VALUE = {
    serviceLevelForecast: 2,
    abandonmentRate: 1,
    occupancy: 2,
    shrinkage: 1,
    effectiveRate: 2,
    costPerWork: 2,
    requiredAgents: 1,
    effectiveAgents: 1,
    supportStaff: 1,
    different: 1,
    productionFte: 1,
    requiredFte: 1,
    requiredHeadcount: 0,
    attrition: 1,
};
export var QUEUE_COLOR = [
    '#267278',
    '#65338D',
    '#4770B3',
    '#D21F75',
    '#3B3689',
    '#50AED3',
    '#48B24f',
    '#E57438',
    '#569DD2',
    '#569D79',
    '#58595B',
    '#E4B031',
    '#84D2F4',
    '#CAD93F',
    '#F5C8AF',
    '#9AC483',
    '#9E9EA2',
];
export var ANNUAL_LAYOUT = {
    title: {
        x: 0.1,
        y: 0.95,
        font: {
            color: '#2a3f5f',
        },
    },
    titlefont: {
        size: 20,
    },
    barmode: 'stack',
    xaxis: {
        type: 'linear',
        tick0: 1,
        dtick: 1,
        tickfont: { size: 16 },
        showline: true,
        linewidth: 6,
        linecolor: '#D7D7D7',
        tickmode: 'array',
        automargin: true,
    },
    yaxis: {
        tickfont: { size: 16 },
        type: 'linear',
        autorange: true,
        categoryorder: 'trace',
        linewidth: 6,
        linecolor: '#D7D7D7',
        zeroline: false,
    },
    autosize: true,
    showlegend: false,
    colorway: QUEUE_COLOR,
};
export var MULTISKILL_COLOR = '#FDFCDD';
export var CONSTRAINT_TYPE_COLOR = theme.palette.grey[500];
export var TOTAL_ROW_COLOR = theme.palette.primary.light;
export var NEST_LEVEL = {
    1: '2rem',
    2: '3rem',
    3: '4rem',
    4: '5rem',
    5: '6rem',
    6: '7rem',
};
export var HIERARCHY_LEVEL = {
    total: 1,
    role: 2,
    lob: 2,
    supportStaffLob: 3,
    queue: 3,
    supportStaffQueue: 4,
    country: 4,
    supportStaffCountry: 5,
    location: 5,
    supportStaffLocation: 6,
    locationQueue: 6,
};
export var getLobExpansionKey = function (lobName) { return "lob:".concat(lobName); };
export var getConstraintExpansionKey = function (lobName, constraintName) {
    return "".concat(getLobExpansionKey(lobName), ":").concat(constraintName);
};
export var getQueueExpansionKey = function (lobName, constraintName, queueName, queueType) {
    return "".concat(getConstraintExpansionKey(lobName, constraintName), ":queue:").concat(queueType !== null && queueType !== void 0 ? queueType : '', ":").concat(queueName);
};
export var getPrefixedExpansionKey = function (prefix, itemName) {
    return prefix ? "".concat(prefix, ":").concat(itemName) : itemName;
};
